const pushDataLayerEvent = (event, data = {}) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event, ...data })
}

let formStepTrackingReady = false

export const initFormStepTracking = () => {
    if (formStepTrackingReady) {
        return
    }

    formStepTrackingReady = true

    document.addEventListener('formie:page:navigate:after', (event) => {
        const nextPageId = event.detail?.pageId

        if (nextPageId === undefined || nextPageId === null) {
            return
        }

        pushDataLayerEvent('form_step_view', {
            form_id: event.target?.id || '',
            form_step: nextPageId
        })
    })
}

export const trackFormThanksPage = (container = document) => {
    if (container?.dataset?.sectionType !== 'pageThanks') {
        return
    }

    pushDataLayerEvent('form_submitted')
}
